/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfIEnumerableOfGuid } from '../../models/platform-api-result-of-i-enumerable-of-guid';

export interface GetUsergroupsUsergroupidQueryAuthorizedapps$Params {
  userGroupId: string;
}

export function getUsergroupsUsergroupidQueryAuthorizedapps(http: HttpClient, rootUrl: string, params: GetUsergroupsUsergroupidQueryAuthorizedapps$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfIEnumerableOfGuid>> {
  const rb = new RequestBuilder(rootUrl, getUsergroupsUsergroupidQueryAuthorizedapps.PATH, 'get');
  if (params) {
    rb.path('userGroupId', params.userGroupId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfIEnumerableOfGuid>;
    })
  );
}

getUsergroupsUsergroupidQueryAuthorizedapps.PATH = '/api/usergroups/{userGroupId}/query/authorizedapps';
